import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { useEffect, useState } from "react";

export default function AboutPage() {
  const [showContactForm, setShowContactForm] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const jsonLdOrg = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "99视频",
    url: "https://99video.com",
    description: "99视频聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门视频平台，提供高清免费在线观看，不缓冲流畅播放。",
  };

  const stats = [
    { value: "5000万+", label: "月活跃用户" },
    { value: "10万+", label: "视频资源" },
    { value: "8大", label: "内容分类" },
    { value: "99.9%", label: "播放流畅率" },
  ];

  const testimonials = [
    {
      name: "张先生",
      role: "电影爱好者",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20friendly%20smile%2C%20clean%20background%2C%20warm%20lighting%2C%20casual%20style&width=120&height=120&seq=avatar-1&orientation=squarish",
      content: "99视频真的太方便了！以前要在好几个APP之间来回切换找资源，现在一个网站就能看香蕉视频、红桃视频、91视频和蜜桃视频的所有内容。4K画质也很清晰，推荐给所有喜欢看电影的朋友！",
    },
    {
      name: "李女士",
      role: "追剧达人",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20photo%2C%20warm%20smile%2C%20clean%20background%2C%20soft%20lighting%2C%20elegant%20style&width=120&height=120&seq=avatar-2&orientation=squarish",
      content: "作为一个追剧狂热者，99视频简直是我的天堂。电视剧更新速度快，分类也很清晰，找剧特别方便。最让我满意的是播放不缓冲，再也不用盯着转圈圈了！",
    },
    {
      name: "王同学",
      role: "动漫迷",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20photo%2C%20bright%20smile%2C%20clean%20background%2C%20modern%20style%2C%20friendly%20expression&width=120&height=120&seq=avatar-3&orientation=squarish",
      content: "动漫分类真的太全了！斗破苍穹、完美世界这些年番都是第一时间更新。画质也是顶级的，3D动画在4K分辨率下看起来特别震撼。支持国产动画，支持99视频！",
    },
  ];

  const milestones = [
    { year: "2024", title: "平台创立", desc: "99视频正式上线，聚合香蕉视频、红桃视频两大平台内容" },
    { year: "2025", title: "快速成长", desc: "接入91视频、蜜桃视频，月活用户突破1000万" },
    { year: "2026", title: "全面升级", desc: "4K超高清全面上线，月活用户突破5000万，成为中国领先的视频聚合平台" },
  ];

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <Breadcrumb
          items={[
            { label: "首页", href: "/" },
            { label: "关于我们" },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-50" aria-label="品牌介绍">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              关于 <strong><span className="text-primary-500">99</span>视频</strong>
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
              99视频是一个创新的在线视频聚合平台，致力于为中国用户提供一站式的视频观看体验。
              我们聚合了香蕉视频、红桃视频、91视频、蜜桃视频等国内热门视频平台的优质内容，
              涵盖电影、电视剧、综艺、动漫、短视频、纪录片、体育和音乐等八大分类，
              让用户无需在多个平台之间切换，即可畅享海量高清视频资源。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-10 max-w-4xl mx-auto">
            {stats.map((stat, idx) => (
              <div key={idx} className="text-center p-4 rounded-lg bg-background-100 border border-background-200">
                <div className="text-2xl md:text-3xl font-bold text-accent-500" style={{ fontFamily: "var(--font-heading)" }}>
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="发展历程">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8" style={{ fontFamily: "var(--font-heading)" }}>
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300 md:-translate-x-px"></div>
              <div className="space-y-6">
                {milestones.map((m, idx) => (
                  <div key={idx} className={`relative flex items-start gap-6 ${idx % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}>
                    <div className="flex-1 md:w-1/2"></div>
                    <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-50 -translate-x-1/2 mt-1.5 z-10"></div>
                    <div className="flex-1 md:w-1/2 ml-10 md:ml-0">
                      <div className={`p-4 rounded-lg bg-background-50 border border-background-200 ${idx % 2 === 1 ? "md:mr-10 md:text-right" : "md:ml-10"}`}>
                        <span className="text-xs text-accent-600 font-semibold">{m.year}</span>
                        <h3 className="text-sm font-bold text-foreground-900 mt-1">{m.title}</h3>
                        <p className="text-xs text-foreground-500 mt-1">{m.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50" aria-label="用户口碑">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8" style={{ fontFamily: "var(--font-heading)" }}>
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {testimonials.map((t, idx) => (
                <div key={idx} className="p-5 rounded-lg bg-background-100 border border-background-200 flex flex-col">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed flex-1">{t.content}</p>
                  <div className="flex items-center gap-0.5 mt-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="联系我们">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8" style={{ fontFamily: "var(--font-heading)" }}>
              联系我们
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">电子邮箱</h3>
                    <p className="text-sm text-foreground-500">contact@99video.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-line text-accent-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">客服热线</h3>
                    <p className="text-sm text-foreground-500">400-888-9999</p>
                    <p className="text-xs text-foreground-400">工作时间：周一至周日 9:00-21:00</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-secondary-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">公司地址</h3>
                    <p className="text-sm text-foreground-500">北京市朝阳区望京科技园A座18层</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-line text-primary-600 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900">微信公众号</h3>
                    <p className="text-sm text-foreground-500">搜索"99视频"关注我们</p>
                  </div>
                </div>
              </div>

              <div>
                {!showContactForm ? (
                  <div className="p-6 rounded-lg bg-background-50 border border-background-200 text-center">
                    <i className="ri-message-3-line text-4xl text-foreground-300"></i>
                    <p className="mt-3 text-sm text-foreground-500">有任何问题或建议？</p>
                    <button
                      onClick={() => setShowContactForm(true)}
                      className="mt-4 px-5 py-2 rounded-full text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      给我们留言
                    </button>
                  </div>
                ) : (
                  <ContactForm onClose={() => setShowContactForm(false)} />
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script type="application/ld+json">{JSON.stringify(jsonLdOrg)}</script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "关于99视频",
          description: "99视频是一个创新的在线视频聚合平台，聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门视频平台的优质内容。",
          url: "https://99video.com/about",
          isPartOf: {
            "@type": "WebSite",
            name: "99视频",
            url: "https://99video.com",
          },
        })}
      </script>
    </>
  );
}

function ContactForm({ onClose }: { onClose: () => void }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formError, setFormError] = useState("");
  const formUrl = "https://api.readdy.ai/api/form/submit";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);

    const honeypotValue = formData.get("phone_alt")?.toString().trim() || "";
    if (honeypotValue) {
      setSubmitted(true);
      return;
    }

    if (!name.trim() || !email.trim() || !message.trim()) {
      setFormError("请填写所有必填字段");
      return;
    }

    if (message.length > 500) {
      setFormError("留言内容不能超过500字符");
      return;
    }

    setSubmitting(true);
    setFormError("");

    try {
      const payload = new URLSearchParams();
      payload.append("name", name);
      payload.append("email", email);
      payload.append("message", message);

      const response = await fetch(formUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed && parsed.code === "OK") {
        setSubmitted(true);
        setName("");
        setEmail("");
        setMessage("");
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || "";
        if (serverMsg.includes("spam")) {
          setSubmitted(true);
        } else {
          setFormError(serverMsg || "提交失败，请稍后重试");
        }
      }
    } catch {
      setFormError("网络错误，请检查连接后重试");
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="p-6 rounded-lg bg-background-50 border border-background-200 text-center">
        <i className="ri-checkbox-circle-line text-4xl text-accent-500"></i>
        <p className="mt-3 text-sm font-medium text-foreground-900">感谢您的留言！</p>
        <p className="text-xs text-foreground-500 mt-1">我们会尽快回复您</p>
        <button
          onClick={onClose}
          className="mt-4 px-4 py-2 text-sm text-primary-500 hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          关闭
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="p-5 rounded-lg bg-background-50 border border-background-200" data-readdy-form>
      <h3 className="text-sm font-semibold text-foreground-900 mb-4">给我们留言</h3>
      {formError && (
        <div className="mb-3 p-2.5 rounded text-xs bg-primary-50 text-primary-700 border border-primary-200">
          {formError}
        </div>
      )}
      <div className="space-y-3">
        <div>
          <label htmlFor="contact-name" className="block text-xs text-foreground-600 mb-1">姓名 *</label>
          <input
            id="contact-name"
            name="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-white focus:outline-none focus:border-primary-400 transition-colors"
            required
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-xs text-foreground-600 mb-1">邮箱 *</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-white focus:outline-none focus:border-primary-400 transition-colors"
            required
          />
        </div>
        <div>
          <label htmlFor="contact-message" className="block text-xs text-foreground-600 mb-1">留言内容 * (限500字)</label>
          <textarea
            id="contact-message"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={4}
            maxLength={500}
            className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-white focus:outline-none focus:border-primary-400 transition-colors resize-none"
            required
          ></textarea>
          <p className="text-xs text-foreground-400 mt-1 text-right">{message.length}/500</p>
        </div>
        <div className="anti-spam-field">
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
        </div>
        <div className="flex items-center gap-2">
          <button
            type="submit"
            disabled={submitting}
            className="px-5 py-2 rounded-full text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 disabled:opacity-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            {submitting ? "提交中..." : "发送留言"}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm text-foreground-500 hover:text-foreground-700 cursor-pointer whitespace-nowrap"
          >
            取消
          </button>
        </div>
      </div>
    </form>
  );
}